import React from "react";
import styles from "./Services.module.css";
import { Service } from "../../types";
import PrimaryServices from "./Primary";
import EquipmentRental from "./Equipment";
import ISOImplementation from "./ISO";

interface ServicesProps {
  primaryServices: Service[];
  equipmentRental: Service[];
  isoImplementation: Service[];
}

const Services: React.FC<ServicesProps> = ({
  primaryServices,
  equipmentRental,
  isoImplementation,
}) => {
  return (
    <section id="services" className={styles.services}>
      <div className="container">
        <div className={styles.sectionTitle}>
          <h2 className={styles.sectionTitleH2}>Our Services</h2>
          <p className={styles.sectionTitleP}>
            We provide comprehensive mining solutions with precision engineering
            and advanced technology.
          </p>
        </div>
        <PrimaryServices services={primaryServices} />
        <EquipmentRental services={equipmentRental} />
        <ISOImplementation services={isoImplementation} />
      </div>
    </section>
  );
};

export default Services;
